import { axiosApiClient, axiosPublicClient } from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/products";

class ProductsService {
  // Categories methods
  getCategories = async () => {
    try {
      const response = await axiosPublicClient.get(`${BASE_URL}/categories`);
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching categories.");
    }
  };

  getFeaturedCategories = async () => {
    try {
      const response = await axiosApiClient.get(
        `${BASE_URL}/categories/featured`
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while fetching featured categories."
      );
    }
  };

  createCategory = async (requestData) => {
    try {
      const response = await axiosApiClient.post(
        `${BASE_URL}/category`,
        requestData
      );
      if (response.status !== 201) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while creating category.");
    }
  };

  deleteCategory = async (id) => {
    try {
      const response = await axiosApiClient.delete(
        `${BASE_URL}/category/${id}`
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while deleting category.");
    }
  };

  toggleCategoryStatus = async (id) => {
    try {
      const response = await axiosApiClient.patch(
        `${BASE_URL}/category/${id}/toggle-status`
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while toggling category status.");
    }
  };

  editCategory = async (id, requestData) => {
    try {
      const response = await axiosApiClient.put(
        `${BASE_URL}/category/${id}`,
        requestData
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while editing category.");
    }
  };

  // Products methods
  getProducts = async (params = {}) => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}`, { params });
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching products.");
    }
  };

  getFeaturedProducts = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/featured`);
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while fetching featured products."
      );
    }
  };

  getProduct = async (id) => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching product.");
    }
  };

  createProduct = async (formData) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.status !== 201) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while creating product.");
    }
  };

  editProduct = async (id, formData) => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while editing product.");
    }
  };

  deleteProduct = async (id) => {
    try {
      const response = await axiosApiClient.delete(`${BASE_URL}/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while deleting product.");
    }
  };

  getLowStockProducts = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/low-stock`);
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching low stock products.");
    }
  };

  getSimilarProducts = async (productId) => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/${productId}/similar`);
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching similar products.");
    }
  };

  // Product Dimensions methods
  getProductDimensions = async (productId) => {
    try {
      const response = await axiosPublicClient.get(`/product-dimensions/${productId}`);
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching product dimensions.");
    }
  };

  saveProductDimensions = async (productId, dimensionsData) => {
    try {
      const response = await axiosApiClient.put(`/product-dimensions/${productId}`, dimensionsData);
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while saving product dimensions.");
    }
  };

  deleteProductDimensions = async (productId) => {
    try {
      const response = await axiosApiClient.delete(`/product-dimensions/${productId}`);
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while deleting product dimensions.");
    }
  };
}

const productsService = new ProductsService();
export default productsService;
